import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAppEventListener } from 'src/common/events/appEvents';
import { api } from 'src/common/utils/api';
import { useAppContainerContext } from '../AppContainerContext';
import type { SteeringResponse } from './types';

type Options = {
  waitingForAction: boolean;
};

export function useNextBestAction({ waitingForAction }: Options) {
  const { contentMeta } = useAppContainerContext();
  const clientId = contentMeta?.entityId ?? null;
  const queryClient = useQueryClient();
  const queryKey = ['steering', 'next-best-action', clientId];

  const query = useQuery<SteeringResponse | null>({
    queryKey,
    queryFn: async () => {
      const res = await api.post<SteeringResponse>('steering/next-best-action', {
        uiContext: { clientId },
      });
      if (res.data.action === 'NO_SUGGESTION') return null;
      return res.data;
    },
    refetchInterval: q => {
      if (waitingForAction) return 10_000;
      return !q.state.data ? 30_000 : 90_000;
    },
  });

  useAppEventListener(event => {
    if (event === 'LOADED_CALENDAR_EVENTS') {
      queryClient.invalidateQueries({ queryKey: ['steering'] });
    }
  });

  return query;
}
